import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const CondolencePasswordAdmin = () => {
  const navigate = useNavigate();
  const [accounts, setAccounts] = useState([]);
  const [source, setSource] = useState('');
  const [loading, setLoading] = useState(true);
  const [resetting, setResetting] = useState(null);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const loadAccounts = useCallback(() => {
    fetch('/api/condolence/admin/accounts', { credentials: 'include' })
      .then(res => {
        if (res.status === 403) { navigate('/condolence/menu'); return null; }
        if (!res.ok) { navigate('/condolence'); return null; }
        return res.json();
      })
      .then(data => {
        if (data) {
          setAccounts(data.accounts || []);
          setSource(data.source || '');
        }
      })
      .catch(() => setError('アカウント一覧の取得に失敗しました'))
      .finally(() => setLoading(false));
  }, [navigate]);

  useEffect(() => { loadAccounts(); }, [loadAccounts]);

  const handleReset = async (targetId) => {
    if (!window.confirm(`ID ${targetId} のパスワードを初期値（Eagle）に戻します。よろしいですか？`)) return;
    setResetting(targetId);
    setMessage('');
    setError('');
    try {
      const res = await fetch('/api/condolence/admin/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ target_id: targetId }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage(`ID ${targetId} のパスワードをリセットしました`);
        loadAccounts();
      } else {
        setError(data.error || 'リセットに失敗しました');
      }
    } catch {
      setError('通信エラーが発生しました');
    } finally {
      setResetting(null);
    }
  };

  return (
    <div className="form-page">
      <header className="form-header" style={{ background: '#37474f' }}>
        <button className="back-button" onClick={() => navigate('/condolence/menu')}>← 戻る</button>
        <h1>アカウント・パスワード管理</h1>
      </header>

      <main className="form-main">
        <div className="section-bar" style={{ background: '#eceff1' }}>
          <span className="icon">🔐</span>
          <span className="title" style={{ color: '#37474f' }}>全アカウント一覧</span>
        </div>

        <div className="form-card">
          {source === 'excel' && (
            <div style={{
              background: '#fff3e0', border: '1px solid #ffcc80', borderRadius: '6px',
              padding: '12px', marginBottom: '16px', color: '#e65100', fontSize: '14px'
            }}>
              現在 Excel フォールバックで動作中のため、パスワードリセットは利用できません（本番DB接続時のみ有効）。
            </div>
          )}
          {message && (
            <div style={{
              background: '#e8f5e9', border: '1px solid #66bb6a', borderRadius: '6px',
              padding: '12px', marginBottom: '16px', color: '#2e7d32'
            }}>{message}</div>
          )}
          {error && <div className="error-message">{error}</div>}

          {loading ? (
            <p style={{ textAlign: 'center', color: '#666' }}>読み込み中...</p>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ borderBottom: '2px solid #37474f' }}>
                  <th style={thStyle}>ID</th>
                  <th style={thStyle}>部署名</th>
                  <th style={thStyle}>状態</th>
                  <th style={thStyle}>操作</th>
                </tr>
              </thead>
              <tbody>
                {accounts.map(acc => (
                  <tr key={acc.id} style={{ borderBottom: '1px solid #eee' }}>
                    <td style={tdStyle}>
                      {acc.id}
                      {acc.is_admin && <span style={{ marginLeft: '6px', fontSize: '11px', background: '#37474f', color: 'white', padding: '2px 6px', borderRadius: '3px' }}>管理者</span>}
                    </td>
                    <td style={tdStyle}>{acc.department}</td>
                    <td style={tdStyle}>
                      {acc.has_changed_password
                        ? <span style={{ color: '#2e7d32' }}>変更済み</span>
                        : <span style={{ color: '#c62828' }}>未変更（初期パス）</span>}
                    </td>
                    <td style={tdStyle}>
                      <button
                        onClick={() => handleReset(acc.id)}
                        disabled={resetting === acc.id || source === 'excel'}
                        style={{
                          padding: '6px 12px', fontSize: '13px',
                          background: source === 'excel' ? '#bdbdbd' : '#c62828',
                          color: 'white', border: 'none', borderRadius: '4px',
                          cursor: source === 'excel' ? 'not-allowed' : 'pointer',
                        }}
                      >
                        {resetting === acc.id ? '処理中...' : 'パスワードリセット'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </main>
    </div>
  );
};

const thStyle = {
  textAlign: 'left', padding: '12px 8px', color: '#37474f', fontSize: '14px', fontWeight: '600'
};
const tdStyle = {
  padding: '12px 8px', fontSize: '14px', color: '#333'
};

export default CondolencePasswordAdmin;
